import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Inicio from './pages/Inicio';
import Catalogo from './pages/Catalogo';
import Contacto from './pages/Contacto';
import Distribuidores from './pages/Distribuidores';
import Tecnico from './pages/Tecnico';
import Mercadeo from './pages/Mercadeo';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppFab from './components/WhatsAppFab';
import ChatTicoBaterin from './components/ChatTicoBaterin';
import RifaRegistro from './pages/RifaRegistro';

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Inicio />} />
        <Route path="/catalogo" element={<Catalogo />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/distribuidores" element={<Distribuidores />} />
        <Route path="/tecnico" element={<Tecnico />} />
        <Route path="/mercadeo" element={<Mercadeo />} />
        <Route path="/rifa" element={<RifaRegistro />} />
        <Route path="/rifa/:slug" element={<RifaRegistro />} />
      </Routes>
      <Footer />
      <WhatsAppFab />
      <ChatTicoBaterin />
    </BrowserRouter>
  );
}

export default App;
